import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BaseElement from '../BaseElement/BaseElement';
import shallowEqual from 'fbjs/lib/shallowEqual';
import {type as MobileTabsElement} from '../MobileTabsElement/MobileTabsElementMetaData';
import InlineStyle from 'crazyEditor/components/Elements/common/InlineStyle';

require('./GlobalStyles/RichTextElement.scss');

const RICH_TEXT_CLASS_NAME = 'cl-rich-text-el';

function getText(elementProps) {
  return elementProps.data.rawHTML;
}

function getEditBoxClassName() {
  return RICH_TEXT_CLASS_NAME;
}

function getEditBoxStyles(elementProps) {
  return {..._.omit(elementProps.compProps, 'zIndex')};
}

function getTextSetter(html) {
  return {
    data: {
      rawHTML: html
    }
  };
}

function getFontSizeInPercentFromDesktop(element) {
  return element.data.fontSizeInPercentFromDesktop || 100;
}

function getFontSizeSetterByPercentFromDesktopElement(element, fontSizeInPercentFromDesktop) {
  return {
    data: {
      fontSizeInPercentFromDesktop,
    }
  };
}

class RichTextElement extends Component {
  constructor(props) {
    super();
    this.state = this.updateHtmlWithFontSize(props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data.rawHTML !== nextProps.data.rawHTML || this.props.compProps !== nextProps.compProps) {
      this.setState(this.updateHtmlWithFontSize(nextProps));
    }
  }

  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  getCSS() {
    const { id } = this.props;
    const {compProps} = this.state;
    let css = `
      #${id} tr, #${id} td {
        border: 1px solid black;
      } `;
    const fontSize = parseInt(compProps.fontSize, 10) || 12;
    css += `#${id} tr, #${id} td, #${id} table {
        font-size: ${fontSize}px;
      } `;
    return css;
  }

  updateHtmlWithFontSize(props) {
    let {rawHTML} = props.data;
    let {compProps} = props;
    const {parentType} = props;
    const {fontSizeInPercentFromDesktop} = props.data;
    if ((props.desktopId || parentType === MobileTabsElement) && fontSizeInPercentFromDesktop) { // applicable only for mobile elements
      const element = document.createElement('div');
      element.innerHTML = rawHTML;
      const allInnerElements = element.getElementsByTagName('*');
      _.forEach(allInnerElements, element => {
        let {fontSize} = element.style;
        if (fontSize) {
          if (_.isString(fontSize)) {
            fontSize = parseInt(fontSize, 10);
          }
          element.style.fontSize = `${Math.ceil(fontSize * fontSizeInPercentFromDesktop / 100)}px`;
        }
      });
      rawHTML = element.innerHTML;
      let {fontSize} = compProps;
      if (fontSize) {
        if (_.isString(fontSize)) {
          fontSize = parseInt(fontSize, 10);
        }
        fontSize = Math.ceil(fontSize * fontSizeInPercentFromDesktop / 100);
        compProps = {...compProps, fontSize};
      }
    }
    return {rawHTML, compProps};
  }

  render() {
    const { editingTextElement, layout } = this.props;
    const compProps = {};
    const {rawHTML} = this.state;
    _.assign(compProps,
      this.state.compProps,
      {
        overflowY: 'auto',
        wordWrap: 'break-word',
        boxSizing: 'border-box',
      }
    );
    if (editingTextElement) {
      // when text is being edited, a copy of the comp is rendered on top of the mouse catcher
      compProps.opacity = 0;
    }
    return (
      <BaseElement {...this.props} compProps={compProps} layout={layout}>
        <InlineStyle css={this.getCSS()} />
        <div className={RICH_TEXT_CLASS_NAME} dangerouslySetInnerHTML={{__html: rawHTML}}/>
      </BaseElement>
    );
  }
}

RichTextElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }),
  data: PropTypes.shape({
    rawHTML: PropTypes.string.isRequired,
    compProps: PropTypes.object
  }),
  editingTextElement: PropTypes.bool,
};

export default {
  elementClass: RichTextElement,
  methods: {
    getText,
    getEditBoxStyles,
    getTextSetter,
    getEditBoxClassName,
    getFontSizeInPercentFromDesktop,
    getFontSizeSetterByPercentFromDesktopElement,
  }
};